import { put, call } from 'redux-saga/effects';
import { dashboardActionRequiredList, dashboardChartDataList, dashboardClientActionRequiredList, dashboardClientChartDataList, shiftTimeChangeRequestCount } from '../services/dashboardService';

import * as types from '../actions';

export function* dashboardActionRequiredListSaga(payload) {
  try {
  	yield put({ type: types.SHOW_LOADER})
    const response = yield call(dashboardActionRequiredList, payload);
    yield put({ type: types.DASHBOARD_ACTION_REQUIRED_LIST_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.DASHBOARD_ACTION_REQUIRED_LIST_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* dashboardChartDataListSaga(payload) {
  try {
  	yield put({ type: types.SHOW_LOADER})
    const response = yield call(dashboardChartDataList, payload);
    yield put({ type: types.DASHBOARD_CHART_DATA_LIST_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.DASHBOARD_CHART_DATA_LIST_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* dashboardClientChartDataListSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(dashboardClientChartDataList, payload);
    yield put({ type: types.DASHBOARD_CLIENT_CHART_DATA_LIST_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.DASHBOARD_CLIENT_CHART_DATA_LIST_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* dashboardClientActionRequiredListSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(dashboardClientActionRequiredList, payload);
    yield put({ type: types.DASHBOARD_CLIENT_ACTION_REQUIRED_LIST_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.DASHBOARD_CLIENT_ACTION_REQUIRED_LIST_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* shiftTimeChangeRequestCountSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(shiftTimeChangeRequestCount, payload);
    yield put({ type: types.SHIFT_TIME_CHANGE_REQUEST_COUNT_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.SHIFT_TIME_CHANGE_REQUEST_COUNT_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}